import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

interface UseDeleteResourceCategoryByIdProps {
  onSuccess?: () => void
  onError?: () => void
}

export const useDeleteResourceCategoryById = ({
  onSuccess,
  onError,
}: UseDeleteResourceCategoryByIdProps = {}) => {
  const queryClient = useQueryClient()
  const deleteCategory = useTypedApiClient({
    path: '/admin/resources/categories/{id}',
    method: 'delete',
  })

  return useMutation({
    mutationKey: ['/admin/resources/categories/{id}', 'delete'],
    mutationFn: async (id: number) => {
      await deleteCategory({ id })
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['/admin/resources/categories'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['/admin/resources'],
        }),
      ])
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })
}
